export const articleQueryKeys = {
  all: ["article"] as const,
  list: () => [...articleQueryKeys.all, "list"] as const,
  detail: (articleId: string) =>
    [...articleQueryKeys.all, "detail", articleId] as const,
  uxEvaluationCount: () =>
    [...articleQueryKeys.all, "uxEvaluationCount"] as const,
};
